import { render, staticRenderFns } from "./contact-person.vue?vue&type=template&id=3b49bbca&"
import script from "./contact-person.vue?vue&type=script&lang=js&"
export * from "./contact-person.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports